import {BaseRouteMetaDataModel} from "../../../infrastructure/models/route/base-route.meta-data.model";

export class CompetitorRouteMetaDataModel extends BaseRouteMetaDataModel {
  get pageTitle() {
    return null
  }

  get description() {
    return null
  }
}